import easelAPI, { getOptions, EaselPayloadResponse } from 'apis/helpers/easelAPI'
import {
  SeoContent as SeoContentResponse,
  SeoContentPage as SeoContentPageResponse,
} from 'types/SeoContent'

export async function fetchPLPSeoContent(): Promise<
  EaselPayloadResponse<SeoContentResponse | SeoContentPageResponse>
> {
  const options = getOptions
  const json = await easelAPI.fetchJSON({
    name: 'fetchPLPSeoContent',
    options,
    url: `/page-content/plp`,
  })
  return json
}
